import ApiService from "../ApiService";

const pendingService = {
  list(page, rowsPerPage, date, search) {
    return ApiService.get(`pending-order?page=${page}&perPage=${rowsPerPage}&searchString=${search}&orderStatus=&dateAfter=${date}&dateBefore=${date}`);
  },
};


export default pendingService;
